module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['FeatureCore']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module FeatureCore URL not available') },
        init: (arg) => { throw new Error('Module FeatureCore URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['FeatureCore'].get(request),
      init: (arg) => {
        try {
          return window['FeatureCore'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: FeatureCore')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module FeatureCore not available') },
      init: (arg) => { throw new Error('Module FeatureCore not available') }
    })
    document.head.appendChild(script);
  });